import Vue from "vue";
import Vuex from "vuex";
import {
  Question,
  RegistrationSettings,
  Settings,
  Program,
  CompletionSettings,
  TestViewSettings,
  ResultViewSettings,
  Modal
} from "@/types";

import Analytics, { AnalyticsState } from "./modules/Analytics";
import IntroSettings from "@/types/IntroSettings";

Vue.use(Vuex);

const AnalyticsObject: AnalyticsState = {
  consent: null
};

const ModalObject: Modal = {
  content: "",
  close_label: ""
};

const SettingsObject: Settings = {
  gdpr_brief: "",
  ga_id: "",
  gdpr_description: "",
  gdpr_close: "",
  name: "",
  _mby: "",
  _by: ""
};

export default new Vuex.Store({
  state: {
    Analytics: AnalyticsObject,
    allPrograms: Array<Program>(),
    allQuestions: Array<Question>(),
    questionQueue: Array<String>(),
    settings: SettingsObject,
    introSettings: Array<IntroSettings>(),
    registrationFormSettings: Array<RegistrationSettings>(),
    completionSettings: Array<CompletionSettings>(),
    testViewSettings: Array<TestViewSettings>(),
    resultViewSettings: Array<ResultViewSettings>(),
    resultProgram: String,
    resultImage: String,
    scrollContentTrigger: false,
    scrollContentPosition: 0,
    loadedSettingsProgress: Array<String>(),
    modalData: ModalObject
  },
  mutations: {
    setAllPrograms(state, n: Program[]) {
      state.allPrograms = n;
    },
    setAllQuestions(state, n: Question[]) {
      state.allQuestions = n;
    },
    setQuestionQueue(state, n: String) {
      state.questionQueue.push(n);
    },
    resetQuestionQueue(state) {
      state.questionQueue = [];
    },
    setSettings(state, n: Settings) {
      state.settings = n;
    },
    setRegistrationFormSettings(state, n: RegistrationSettings[]) {
      state.registrationFormSettings = n;
    },
    setTestViewSettings(state, n: TestViewSettings[]) {
      state.testViewSettings = n;
    },
    setResultViewSettings(state, n: ResultViewSettings[]) {
      state.resultViewSettings = n;
    },
    setIntroSettings(state, n: IntroSettings[]) {
      state.introSettings = n;
    },
    setCompletionSettings(state, n: CompletionSettings[]) {
      state.completionSettings = n;
    },
    setResultProgram(state, n) {
      state.resultProgram = n;
    },
    setResultImage(state, n) {
      state.resultImage = n;
    },
    setScrollContentTrigger(state) {
      state.scrollContentTrigger = !state.scrollContentTrigger;
    },
    setScrollContentPosition(state, n) {
      state.scrollContentPosition = n;
    },
    setLoadedSettingsProgress(state, n: String) {
      state.loadedSettingsProgress.push(n);
    },
    commitModalData(state, n: Modal) {
      state.modalData = n;
    }
  },
  actions: {
    triggerScrollTop({ commit }) {
      commit("setScrollContentTrigger");
    },
    setModalData({ commit }, data: Modal) {
      commit("commitModalData", data);
    },
    clearModalData({ commit }) {
      commit("commitModalData", ModalObject);
    }
  },
  modules: {
    Analytics
  }
});
